// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "promo-1WC6J";
var _4 = "promo__image-UosII";
var _5 = "withoutContent-1AXFF";
var _6 = "promo__content-2OrWQ";
export { _1 as "__esModule", _2 as "mobile", _3 as "promo", _4 as "promo__image", _5 as "withoutContent", _6 as "promo__content" }
export default { "__esModule": _1, "mobile": _2, "promo": _3, "promo__image": _4, "withoutContent": _5, "promo__content": _6 }
